import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useAuth } from 'context/AuthContext';
import Avatar from 'funifier-nice-avatar';
import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';

import inovacao from 'assets/img/bg-inovacao.png';
import foco from 'assets/img/bg-foco.png';
import resolutividade from 'assets/img/bg-resolutividade.png';
import colaboracao from 'assets/img/bg-colaboracao.png';
import heart from 'assets/img/heart-icon.svg';

import { SeloColaboracao, SeloFocoNoCliente, SeloInovacao, SeloResolutividade } from 'components/icons';
import Button from 'components/ui/button';

import './style.scss';
import { Link } from 'react-router-dom';

const behaviors: any = {
  colaboracao: {
    id: 'colaboracao',
    icon: <SeloColaboracao size={'100%'} />,
    img: colaboracao,
    css: 'absolute top-[107px] left-[81px] -rotate-3 w-[202px] h-[198px]',
  },
  foco: {
    id: 'foco',
    icon: <SeloFocoNoCliente size={'100%'} />,
    img: foco,
    css: 'absolute top-[107px] left-[81px] -rotate-3 w-[202px] h-[198px]',
  },
  inovacao: {
    id: 'inovacao',
    icon: <SeloInovacao size={'100%'} />,
    img: inovacao,
    css: 'absolute top-[114px] left-[77px] -rotate-3 w-[198px] h-[195px]',
  },
  resolutividade: {
    id: 'resolutividade',
    icon: <SeloResolutividade size={'100%'} />,
    img: resolutividade,
    css: 'absolute top-[107px] left-[81px] -rotate-3 w-[202px] h-[198px]',
  },
};

interface UserBadgeProps {
  badge: any;
  type?: string
}

export default function UserBadge({ badge, type }: UserBadgeProps) {
  const { user } = useAuth();

  const downloadImage = async (imageUrl: string) => {
    try {
      const regionalSrc = imageUrl.replace(
        /^https:\/\/s3\.amazonaws\.com\/([^/]+)\/(.+)$/,
        'https://$1.s3.amazonaws.com/$2',
      );

      const response = await fetch(regionalSrc, { mode: 'cors' });

      if (!response.ok) {
        throw new Error(`Erro ao buscar imagem convertida: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `selo_joga_Junto_${type}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Erro ao fazer o download da imagem:', error);
    }
  };

  const hasImage = useMemo(() => {
    try {
      if (user?.extra?.avatar_type === 1 && badge?.selo?.url) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }, [badge, user]);

  // async function download() {
  //   const node = document.getElementById('userBadge');
  //   const scale = 2;

  //   if (node)
  //     domtoimage
  //       .toPng(node, {
  //         height: node.offsetHeight * scale,
  //         style: {
  //           transform: `scale(${scale}) translate(${
  //             node.offsetWidth / 2 / scale
  //           }px, ${node.offsetHeight / 2 / scale}px)`,
  //           'border-radius': 0,
  //         },
  //         width: node.offsetWidth * scale,
  //       })
  //       .then(function (dataUrl) {
  //         var link = document.createElement('a');
  //         link.download = 'destaque-cultura-bb.png';
  //         link.href = dataUrl;
  //         link.click();
  //       })
  //       .catch(function (error) {
  //         console.error('oops, something went wrong!', error);
  //       });
  // }

  return user && user?._id && badge && badge._id ? (
    <div id="badgeUser" className="relative flex flex-col items-center -mx-5 lg:mx-0">
      {!!hasImage ? (
        <>
          <div className="bg-maastricht-blue p-4 rounded-[20px]">
            <img
              className="w-full lg:w-auto rounded-[20px] h-auto xl:h-[272px] block"
              src={badge?.selo?.url}
              alt={`Selo JogaJunto: ${type || 'conquista'}`}
            />
          </div>

          {/* <div id="userBadge" className="w-fit h-fit">
            <div className="relative">
              <img
                className="h-[400px]"
                src={behaviors[behavior].img}
                alt="JogaJunto badge"
              />

              {!!user.extra.avatar_type &&
                (!!user?.image?.medium.url ? (
                  <img
                    id="imageProfile"
                    src={user?.image?.medium.url}
                    alt={user.name}
                    className={behaviors[behavior].css}
                  />
                ) : (
                  <div
                    className={
                      behaviors[behavior].css +
                      ' bg-purple flex items-center justify-center text-3xl font-bold'
                    }
                  >
                    {user.name[0]}
                  </div>
                ))}
              {!user.extra.avatar_type &&
                (!!user.extra.avatar ? (
                  <Avatar
                    className={behaviors[behavior].css + ' avatar'}
                    {...user.extra.avatar}
                  />
                ) : (
                  <div
                    className={
                      behaviors[behavior].css +
                      ' bg-purple flex items-center justify-center text-3xl font-bold'
                    }
                  >
                    {user.name[0]}
                  </div>
                ))}

              <div className="w-20 absolute top-[99px] right-[20px] rotate-12">
                {behaviors[behavior].icon}
              </div>

              <div className="w-14 absolute bottom-[81px] right-[53px] rotate-12">
                <img src={heart} alt="Ícone de coração" />
              </div>
            </div>
          </div> */}

          <div className="mt-5 flex flex-col items-center justify-center">
            <button
              onClick={() => downloadImage(badge?.selo?.url)}
              className="bg-purple text-center w-full text-white hover:text-white active:text-white focus:text-white hover:ring hover:ring-white rounded-md shadow-xl font-bold px-6 py-3 uppercase inline-block no-underline hover:no-underline active:no-underline focus:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow"
              aria-label={`Baixar imagem do selo ${type || 'conquista'}`}
            >
              <span className="p-1 leading-tight">Baixar imagem</span>
            </button>

            {/* <a
              href={badge?.selo?.url}
              target="_blank"
              rel="noopener noreferrer"
              download={'destaque-cultura-bb.png'}
              className="w-full mt-4 text-center bg-transparent border-2 border-purple hover:text-white hover:border-white rounded-md shadow-xl font-bold px-6 py-3 uppercase inline-block no-underline hover:no-underline active:no-underline focus:no-underline"
            >
              <span className="p-1 leading-tight">Baixar imagem</span>
            </a> */}
          </div>
        </>
      ) : (
        <div className="block space-y-3">
          <p className="text-base text-yellow font-semibold" tabIndex={0}>
            <strong>Compartilhe sua conquista!</strong>
          </p>
          <p className="max-w-[400px] font-thin" tabIndex={0}>
            Para ter uma foto para compartilhamento, você precisa alterar sua foto de perfil, fazendo o upload com sua imagem.
            Clique no botão abaixo para fazer o upload.
          </p>
          <Link
            to="/?avatar=atualizar"
            className="bg-purple text-white hover:text-white active:text-white focus:text-white hover:ring hover:ring-white rounded-md shadow-xl font-bold px-6 py-3 uppercase inline-block no-underline hover:no-underline active:no-underline focus:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow"
            aria-label="Atualizar minha foto de perfil para compartilhar conquista"
          >
            <span className="p-1 leading-tight">ATUALIZAR MINHA FOTO DE PERFIL</span>
          </Link>
        </div>
      )}
    </div>
  ) : (
    <></>
  );
}
